import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import CreateAppButton from '../../components/create-app-button';
import api from '../../images/api.gif';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
      <h2>{`API Quickstart Guide`}</h2>
      <img src={api} width={860} />
      <p>{`Welcome to GIPHY API, where you can seamlessly integrate your app with the largest GIF and Sticker library in the world.`}</p>
      <p>{`GIPHY API is simple and fast to use, but if you're looking for something with automatic updates and access to exclusive features, our SDK might be an even better fit for you — `}<a href="/docs/sdk">{`check out GIPHY SDK!`}</a></p>
      <h2>{`Quickstart`}</h2>
      <p>{`Before you get started with GIPHY API, you first have to obtain an API Key by creating an app. Don't worry: it's free, and you can change your app's name and description at any time. Please note: if you're planning a large-scale deployment you must request a production API Key from your user dashboard.`}</p>
      <CreateAppButton mdxType="CreateAppButton" />
      <p>{`Once you’ve created an app and obtained an API key, simply follow these two easy steps to get up-and-running with GIPHY API.`}</p>
      <h3>{`1. Implement Search`}</h3>
      <p>{`GIPHY Search returns the most relevant GIFs and Stickers based on a user’s search query or category specification. Users can even find GIFs and Stickers using emoji!`}</p>
      <p>{`To add Search to your app, head to the `}<a href="/docs/api/endpoint#search">{`Search Endpoint`}</a>{`.`}</p>
      <p>{`To see what it should look like, you can take a look at our example code `}<a href="/docs/resource#code-examples">{`here`}</a>{`.`}</p>
      <h3>{`2. Incorporate Analytics`}</h3>
      <p>{`GIPHY uses GIPHY Analytics to improve search results for your users. By calling our `}<a href="/docs/api/endpoint#action-register">{`Action Register Endpoint`}</a>{` each time a user views, clicks, or sends a GIF or Sticker, we will be able to customize our responses to your user's behavior. We highly recommend calling this endpoint on every user action in your app.`}</p>
      <p>{`To add analytics to your app, head to our `}<a href="/docs/api/endpoint#action-register">{`Action Register Endpoint`}</a>{`.`}</p>
      <h2>{`Attribution`}</h2>
      <p>{`We require all apps that use GIPHY API to conspicuously display `}<strong parentName="p">{`"Powered By GIPHY"`}</strong>{` attribution marks where the API is utilized (see SDK attribution guide `}<a href="/docs/sdk#design-guidelines">{`here`}</a>{`). You can find approved `}<a parentName="p" {...{
          "href": "http://giphymedia.s3.amazonaws.com/giphy-attribution-marks.zip"
        }}>{`official logo marks here`}</a>{`.`}</p>
      <p><em parentName="p">{`Before getting started with GIPHY API, please take a look at our `}<a parentName="em" {...{
            "href": "https://support.giphy.com/hc/en-us/articles/360028134111-GIPHY-API-Terms-of-Service-"
          }}>{`API Terms of Service.`}</a>{`. If you currently are using GIPHY API, then the `}<a parentName="em" {...{
            "href": "https://support.giphy.com/hc/en-us/articles/360028134111-GIPHY-API-Terms-of-Service-"
          }}>{`API Terms of Service`}</a>{` apply.`}</em></p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      